import React from "react";
import PageHeading from "../components/page-heading";

import img1 from "../assets/team/1.jpg";

import { NAME } from "../constants";
import SliderNoTitle from "../components/slider-no-title";

const meta = {
    title: "About",
    description:
        "Touchlife Medical Care Foundation is a nonprofit health center located in Ober, Oyam district Northern Uganda. It brings improved medical services closer to the people and seeks to reach out and meet the wholistic health need of the community in which it serves.",
    keywords: ["Touchlife", "Touchlife Medical Care Foundation"],
};

// Remove `Metadata` type (it's TS-only)
export const metadata = {
    title: meta.title,
    description: meta.description,
    keywords: meta.keywords,
    twitter: {
        card: "summary_large_image",
        title: meta.title,
        description: meta.description,
        siteId: "1467726470533754880",
        creator: NAME,
        creatorId: "1467726470533754880",
    },
};

function AboutPage() {
    const mission = [
        {
            title: "Our Vision",
            description:
                "Transformation and restoration of lives of people at grassroots through provision of efficient and cost – effective high quality healthcare services.",
        },
        {
            title: "Our Mission",
            description:
                "To create an environment that enables people at the grassroots to access quality medical services ,uphold the value of life, treat our patients with respect and dignity.",
        },
    ];

    const values = [
        {
            title: "Integrity",
            description:
                "We pride ourselves in transparency and accountability to moral and Ethical principles. ",
        },
        {
            title: "Quality & Consistency",
            description:
                "We strive to deliver excellent and exceptional, wholistic care in all that we do continually. ",
        },
        {
            title: "Steward",
            description:
                "God being the ultimate source of healing & Provision, we strive to manage the resources entrusted to us with the utmost care and responsibility. ",
        },
        {
            title: "Involvement ",
            description:
                "Teamwork and collaboration is our strength and we welcome, value and recognize the contribution of our clients, partners and volunteers in serving our community medical needs.",
        },
        {
            title: "Relationship ",
            description:
                "Creating conducive environment for all our staff and patients based on trust and mission commitment. ",
        },
    ];

    return (
        <div>
            <PageHeading title="About us" />
            <div className="py-16 container">
                <h2 className="headings mb-6 text-center">
                    About TouchLife Medical Care Foundation
                </h2>
                <h3 className="text-lg mb-3">
                    Touchlife Medical Care Foundation is a nonprofit health center located
                    in Ober, Oyam district Northern Uganda.
                </h3>
                <p>
                    The community of Ober is faced with various health challenges and lack
                    proper medical facilities within its vicinity to serve its people.
                    Ober has lost quite a big number of people especially women and
                    children due to maternal health challenges, malaria, mental health
                    issues, addictions and nutritional needs, that could have been avoided
                    with proper medical and psychological attention. There is a high need
                    within the community of Ober for a decent medical facility to curb
                    these challenges.
                </p>

                <div className="mt-10 grid lg:grid-cols-2 gap-10 items-center">
                    <SliderNoTitle images={[img1]} title={NAME} />
                    <div className="flex flex-col gap-3">
                        <p>
                            At Touchlife, we bring improved medical services closer to the
                            people and seek to reach out and meet the wholistic health need of
                            the community in which we serve. That is the physical,
                            psychological, social and spiritual wellbeing of the community.
                        </p>
                        <p>
                            Ober is an impoverished community where its people live below the
                            minimal wage. We at Touchlife believe that medical care is a basic
                            human right and should be accessible to all. Medical care which is
                            a great need in this area, sadly remains unaffordable to many.
                        </p>
                        <p>
                            Touchlife on the other hand strives to make medical care
                            affordable. However, despite offering services at a much reduced
                            rate, many in the community are still unable to afford medical
                            care. On the other hand, there are pending needs of the facility
                            to still be fulfilled in order to serve the people of Ober better.
                            This greatly affects the number of patients on a daily. With
                            partnership from well-wishers Touchlife wishes to make medical
                            care more affordable and accessible to the poor and marginalized.
                        </p>
                    </div>
                </div>

                <div className="grid lg:grid-cols-2 mt-20 gap-6 lg:gap-10">
                    {mission.map((m, i) => (
                        <div key={i} className="main-bg rounded p-6">
                            <h4 className="text-white font-semibold text-xl mb-3">
                                {m.title}
                            </h4>
                            <p className="text-white">{m.description}</p>
                        </div>
                    ))}
                </div>

                <h2 className="text-4xl font-semibold mt-20 leading-snug text-center">
                    Core Values
                </h2>

                <div className="grid md:grid-cols-2 xl:grid-cols-3 mt-12 gap-10">
                    {values.map((v, i) => (
                        <div key={i} className="border rounded p-6 text-center">
                            <h4 className="font-semibold text-xl mb-3 main-color">
                                {v.title}
                            </h4>
                            <p>{v.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AboutPage;
